export default {
  operatedBy: 'Opéré par',
  partlyOperatedBy: 'Partiellement opéré par',
  operatedByGerman: '',
}
